import classNames from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";
import { useMultimediaTypes } from "../../../services/helpers/multimedia";

export const MultimediaTypesFilter = ({
  activeType,
  setActiveType,
  className,
}) => {
  const { t } = useTranslation(["globals"]);
  const multimediaTypes = useMultimediaTypes();

  return (
    <div className={classNames("Sections__tags", className)}>
      <div
        key="category-all"
        className={classNames({
          Sections__tag: true,
          "is-active": !activeType,
        })}
        onClick={() => setActiveType(null)}
      >
        {t("globals:articles.tagsall")}
      </div>
      {multimediaTypes.map(({ id, name }) => (
        <div
          key={id}
          className={classNames({
            Sections__tag: true,
            "is-active": activeType === id,
          })}
          onClick={() => setActiveType(id)}
        >
          {name}
        </div>
      ))}
    </div>
  );
};
